import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './PlgUsageWarningBanner.css';
import '../Billing/PlgCancelModal.css';
import { CANCEL_REASONS } from '../Billing/plgCancelReasons';
import billing from '../../api/billing';
import DialogBox from '../Modal/DialogBox';

const verizonLogo = process.env.PUBLIC_URL + '/assets/media/brand/verizone.png';
const attLogo = process.env.PUBLIC_URL + '/assets/media/brand/allcarrier.png';

class PlgUsageWarningBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dismissed: false,
            trialDismissed: false,
            loading: true,
            plgUsage: null,
            showWarning: false,
            showPlgCancelModal: false,
            plgCancelInfo: null,
            plgCancelInfoLoading: false,
            alertModal: { show: false, title: '', message: '' },
            cancelReason: '',
            cancelReasonOther: '',
        };

    }

    componentDidMount() {
        this.fetchPlgUsage();
        window.addEventListener('plg-plan-changed', this.fetchPlgUsage);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user?.user_id !== this.props.user?.user_id) {
            this.fetchPlgUsage();
        }
        this.updateBodyClass();
    }

    componentWillUnmount() {
        document.body.classList.remove('plg-banner-visible');
        window.removeEventListener('plg-plan-changed', this.fetchPlgUsage);
    }

    fetchPlgUsage = async () => {
        const { user } = this.props;

        if (!user || !user.user_id) {
            this.setState({ loading: false });
            return;
        }

        try {
            const response = await billing.GetPlgUsage({ user_id: user.user_id });

            if (response.status && response.is_plg_account) {
                this.setState({
                    loading: false,
                    plgUsage: response,
                    showWarning: response.warning === true
                });
            } else {
                this.setState({
                    loading: false,
                    plgUsage: null,
                    showWarning: false
                });
            }
        } catch (error) {
            console.error('Error fetching PLG usage:', error);
            this.setState({
                loading: false,
                plgUsage: null,
                showWarning: false
            });
        }
    }

    isTruthyFlag = (value) => {
        return value === true || value === 1 || value === '1' || value === 'true';
    }

    isFalseFlag = (value) => {
        return value === false || value === 0 || value === '0' || value === 'false';
    }

    isOnBillingPage = () => {
        const pathname = this.props.location?.pathname || window.location.pathname || '';
        const search = this.props.location?.search || window.location.search || '';
        const tab = new URLSearchParams(search).get('tab');
        return pathname.replace(/\/+$/, '') === '/settings' && tab === 'billing';
    }

   shouldShowTrialBanner = () => {
    const { plgUsage, trialDismissed } = this.state;
    const isInTrial = this.isTruthyFlag(plgUsage?.is_in_trial);

    // Trial exists if trial has started (whether ongoing or ended)
    const trialExists = plgUsage?.trial_started_at;

    // Show banner if:
    // - not dismissed
    // - trial is ongoing OR trial has ended
    return !trialDismissed && (isInTrial || trialExists);
}


    updateBodyClass = () => {
        const { dismissed, showWarning, plgUsage } = this.state;
        const isInTrial = this.isTruthyFlag(plgUsage?.is_in_trial);
        const showUsageWarning = !dismissed && showWarning && !isInTrial;

        if (this.shouldShowTrialBanner() || showUsageWarning) {
            document.body.classList.add('plg-banner-visible');
        } else {
            document.body.classList.remove('plg-banner-visible');
        }
    }

    handleDismiss = () => {
        this.setState({ dismissed: true });
    }

    handleTrialDismiss = () => {
        this.setState({ trialDismissed: true });
    }

    renderTrialBanner() {
        const { plgUsage } = this.state;
        const daysRemaining = plgUsage?.trial_days_remaining || 0;
        const totalDays = plgUsage?.trial_total_days || 14;
        const trialEnded = !this.isTruthyFlag(plgUsage?.is_in_trial)
            && this.isFalseFlag(plgUsage?.has_plan)
            && plgUsage?.trial_started_at;

        // SVG ring: radius 28, circumference ~175.93
        const radius = 28;
        const circumference = 2 * Math.PI * radius;
        const progress = totalDays > 0 ? daysRemaining / totalDays : 0;
        const dashOffset = circumference * (1 - progress);

        return (
            <div className="plg-trial-banner">
                <div className="plg-trial-banner__left">
                    <div className="plg-trial-ring">
                        <svg width="72" height="72" viewBox="0 0 72 72">
                            {/* White fill background */}
                            <circle cx="36" cy="36" r="34" fill="#ffffff" />
                            {/* Track */}
                            <circle
                                cx="36" cy="36" r={radius}
                                fill="none"
                                stroke="#d1faf4"
                                strokeWidth="4"
                            />
                            {/* Progress arc (teal) */}
                            <circle
                                cx="36" cy="36" r={radius}
                                fill="none"
                                stroke="#38B2AC"
                                strokeWidth="4"
                                strokeDasharray={circumference}
                                strokeDashoffset={dashOffset}
                                strokeLinecap="round"
                                transform="rotate(-90 36 36)"
                            />
                        </svg>
                        <div className="plg-trial-ring__label">
                            <span className="plg-trial-ring__days">{daysRemaining}</span>
                            <span className="plg-trial-ring__unit">days</span>
                        </div>
                    </div>
                </div>

                <div className="plg-trial-banner__body">
                    <p className="plg-trial-banner__title">
                        {trialEnded
                            ? <strong>Your trial has ended</strong>
                            : <>Trial time remaining: <strong>{daysRemaining} day{daysRemaining !== 1 ? 's' : ''}</strong></>
                        }
                    </p>
                    <p className="plg-trial-banner__subtitle">
                        Add billing details to keep your service uninterrupted.
                    </p>
                </div>

                <div className="plg-trial-banner__action">
                    {/* Hide "Go to Billing" when already on the billing settings page */}
                    {!this.isOnBillingPage() && (
                        <a
                            href="/settings?tab=billing"
                            className="plg-trial-banner__btn btn linear-gradient yr-submitbtn btn-sm"
                            style={{ marginRight: 8 }}
                        >
                            Go to Billing
                        </a>
                    )}
                    <button
                        type="button"
                        className="plg-trial-banner__btn btn linear-gradient yr-submitbtn btn-sm"
                        disabled={this.state.plgCancelInfoLoading}
                        onClick={this.handleCancelClick}
                    >
                        {this.state.plgCancelInfoLoading ? 'Loading...' : 'Removal Instructions'}
                    </button>
                </div>
            </div>
        );
    }

    renderUsageWarningBanner() {
        const { plgUsage } = this.state;
        const plan_calls = plgUsage?.calls_in_plan ||0;
        return (
            <div className="plg-usage-warning-banner">
                <div className="banner-content">
                    <div className="banner-main">
                        <i className="fa fa-exclamation-triangle banner-icon" aria-hidden="true"></i>
                        <span className="banner-message">
                             You are about to exceed your allocated {plan_calls} calls in your current subscription please visit your billing section to upgrade your subscription
                            
                        </span>
                    </div>
                    <button
                        type="button"
                        className="btn-dismiss"
                        onClick={this.handleDismiss}
                        aria-label="Close"
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        );
    }

    handleCancelClick = () => {
        const { user } = this.props;
        this.setState({ plgCancelInfoLoading: true });
        billing.plgCancelInfo({ user_id: user.user_id })
            .then((resp) => {
                this.setState({ plgCancelInfoLoading: false });
                if (resp && resp.status) {
                    if (resp.cancellation_details) {
                        this.setState({ alertModal: { show: true, title: 'Already Cancelled', message: 'Your subscription has already been cancelled.' } });
                        return;
                    }
                    this.setState({ plgCancelInfo: resp, showPlgCancelModal: true, cancelReason: '', cancelReasonOther: '' });
                }
            })
            .catch(() => this.setState({ plgCancelInfoLoading: false }));
    }

    confirmPlgCancellation = () => {
        const { user } = this.props;
        const { plgCancelInfo, cancelReason, cancelReasonOther } = this.state;
        this.setState({ showPlgCancelModal: false, cancelReason: '', cancelReasonOther: '' });
        billing.plgCancelSubscription({
            subscription_id: plgCancelInfo?.subscription_id,
            user_id: user.user_id,
            subscription_status: 'ACTIVE',
            cancellation_reason: cancelReason,
            cancellation_reason_other: cancelReason === 'Other' ? cancelReasonOther.trim() : null,
        }).then((resp) => {
            if (resp && resp.msg === 'done') {
                this.setState({
                    alertModal: {
                        show: true,
                        title: 'Subscription Cancelled',
                        message: 'Your subscription has been cancelled and will remain active until the end of the billing period.',
                        onClose: () => window.dispatchEvent(new Event('plg-plan-changed')),
                    }
                });
            } else if (resp && resp.msg === 'already_cancelled') {
                this.setState({ alertModal: { show: true, title: 'Already Cancelled', message: 'Your subscription is already cancelled.' } });
            } else {
                const msg = (resp && resp.message) ? resp.message : 'Unable to cancel subscription. Please try again.';
                this.setState({ alertModal: { show: true, title: 'Error', message: msg } });
            }
        }).catch(() => {
            this.setState({ alertModal: { show: true, title: 'Error', message: 'Unable to cancel subscription. Please try again.' } });
        });
    }

    formatPhoneDisplay = (phone) => {
        if (!phone) return '';
        const digits = phone.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) {
            const d = digits.slice(1);
            return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
        }
        if (digits.length === 10) {
            return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        }
        return phone;
    }

    renderCancelModal() {
        const { showPlgCancelModal, plgCancelInfo } = this.state;
        if (!showPlgCancelModal) return null;

        const aiNumber = this.formatPhoneDisplay(plgCancelInfo?.twilio_phone || '') || plgCancelInfo?.twilio_phone || '';

        const step = (n) => <span className="plg-cancel-modal__step-num">{n}</span>;
        const row = (n, text) => (
            <div className="plg-cancel-modal__step">
                {step(n)}
                <span className="plg-cancel-modal__step-text">{text}</span>
            </div>
        );
        const dialBox = (code, isPhone = false) => (
            <div className={`plg-cancel-modal__dial-box${isPhone ? ' plg-cancel-modal__dial-box--phone' : ''}`}>{code}</div>
        );
        const columnFooter = (text) => <p className="plg-cancel-modal__column-footer">{text}</p>;
        const carrierLogo = (src, alt) => (
            <img src={src} alt={alt} className="plg-cancel-modal__carrier-logo" />
        );

        return (
            <div className="plg-cancel-modal">
                <div className="plg-cancel-modal__card">
                    <div className="plg-cancel-modal__body">
                        <div className="plg-cancel-modal__header-row">
                            <div className="plg-cancel-modal__header-left">
                                <h2 className="plg-cancel-modal__title">
                                    Cancel Subscription &amp; Remove Call Forwarding
                                </h2>
                                <p className="plg-cancel-modal__subtitle">
                                    Your subscription will remain active until the end of your current billing period.
                                </p>
                                <p className="plg-cancel-modal__subtitle">
                                    To ensure your calls continue routing correctly, you must remove call forwarding.
                                </p>
                            </div>
                            <div className="plg-cancel-modal__important">
                                <div className="plg-cancel-modal__important-head">
                                    <i className="fa fa-info-circle" aria-hidden />
                                    <strong>Important</strong>
                                </div>
                                <p>
                                    If you cancel without removing call forwarding, calls may continue to be sent to this number once your subscription ends.
                                </p>
                            </div>
                        </div>

                        {aiNumber && (
                            <div className="plg-cancel-modal__ai-box">
                                <div className="plg-cancel-modal__ai-icon">
                                    <i className="fa fa-phone-square" aria-hidden />
                                </div>
                                <div>
                                    <div className="plg-cancel-modal__ai-label">AI Receptionist Number</div>
                                    <div className="plg-cancel-modal__ai-number">{aiNumber}</div>
                                    <div className="plg-cancel-modal__ai-note">This is the number currently receiving your forwarded calls.</div>
                                </div>
                            </div>
                        )}

                        <p className="plg-cancel-modal__instructions-title">
                            How to remove call forwarding and restore your normal voicemail
                        </p>
                        <p className="plg-cancel-modal__instructions-sub">
                            Dial the code below from the phone number you used to set up call forwarding to stop forwarding.
                        </p>

                        <div className="plg-cancel-modal__columns">
                            <div className="plg-cancel-modal__column plg-cancel-modal__column--verizon">
                                <div className="plg-cancel-modal__brand-logo-wrap" style={{ marginTop: '10px', marginBottom: '10px' }}>
                                    {carrierLogo(verizonLogo, 'Verizon')}
                                </div>
                                <p className="plg-cancel-modal__column-title">To restore Verizon voicemail:</p>
                                {row(1, 'Open your Phone app.')}
                                {row(2, 'Dial:')}
                                {dialBox('*73')}
                                {row(3, 'Tap Call.')}
                                {row(4, 'Wait for confirmation.')}
                                {columnFooter('Your calls will now return to Verizon voicemail.')}
                            </div>

                            <div className="plg-cancel-modal__column plg-cancel-modal__column--carriers">
                                <p className="plg-cancel-modal__column-title">
                                    All other carriers (including Canada) and other mobile providers
                                </p>
                                <div className="plg-cancel-modal__carrier-logos">
                                    {carrierLogo(attLogo, 'allcarrier')}
                                </div>
                                <p className="plg-cancel-modal__column-title">To restore your voicemail:</p>
                                {row(1, 'Open your Phone app.')}
                                {row(2, 'Dial:')}
                                {dialBox('##004#')}
                                {row(3, 'Tap Call.')}
                                {row(4, 'Wait for confirmation.')}
                                {columnFooter('Your calls will now return to your normal voicemail.')}
                            </div>

                            <div className="plg-cancel-modal__column plg-cancel-modal__column--voip">
                                <div className="plg-cancel-modal__voip-head">
                                    <div className="plg-cancel-modal__voip-icon">
                                        <i className="fa fa-fax" aria-hidden />
                                    </div>
                                    <p className="plg-cancel-modal__column-title plg-cancel-modal__voip-title">
                                        Using a VoIP or Business Phone System?
                                    </p>
                                </div>
                                <p className="plg-cancel-modal__voip-intro">
                                    To stop calls from being sent to the AI Receptionist number:
                                </p>
                                {row(1, 'Log in to your phone system admin portal.')}
                                {row(2, 'Remove any call forwarding or call routing that sends calls to:')}
                                {aiNumber && dialBox(aiNumber, true)}
                                {row(3, 'Restore your previous routing or voicemail settings.')}
                                {columnFooter('After removing the AI number, calls will follow your normal business phone system rules.')}
                            </div>
                        </div>

                        <div className="plg-cancel-modal__reason-section">
                            <p className="plg-cancel-modal__reason-title">
                                Why are you cancelling?<span>*</span>
                            </p>
                            <ul className="plg-cancel-modal__reason-list">
                                {CANCEL_REASONS.map((reason) => (
                                    <li key={reason}>
                                        <label className="plg-cancel-modal__reason-option">
                                            <input
                                                type="radio"
                                                name="plg-cancel-reason-banner"
                                                value={reason}
                                                checked={this.state.cancelReason === reason}
                                                onChange={() => this.setState({ cancelReason: reason, cancelReasonOther: '' })}
                                            />
                                            <span className="plg-cancel-modal__reason-option-label">{reason}</span>
                                        </label>
                                    </li>
                                ))}
                            </ul>
                            {this.state.cancelReason === 'Other' && (
                                <div className="plg-cancel-modal__reason-other-wrap">
                                    <textarea
                                        className="plg-cancel-modal__reason-other-textarea"
                                        placeholder="Please describe your reason..."
                                        maxLength={1000}
                                        value={this.state.cancelReasonOther}
                                        onChange={(e) => this.setState({ cancelReasonOther: e.target.value })}
                                    />
                                    <div className="plg-cancel-modal__reason-other-meta">
                                        {this.state.cancelReasonOther.trim() === '' && (
                                            <span className="plg-cancel-modal__reason-other-error">Please enter a reason to continue.</span>
                                        )}
                                        <span className="plg-cancel-modal__reason-other-count">{this.state.cancelReasonOther.length}/1000</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="plg-cancel-modal__warning">
                            <i className="fa fa-exclamation-triangle" aria-hidden />
                            <span>
                                <strong>Important:</strong> Your subscription cancellation will not automatically remove call forwarding.
                                Follow the instructions above to ensure callers reach your normal voicemail or business phone system after service ends.
                            </span>
                        </div>
                    </div>

                    <div className="plg-cancel-modal__footer">
                        <button
                            type="button"
                            onClick={() => this.setState({ showPlgCancelModal: false, plgCancelInfo: null, cancelReason: '', cancelReasonOther: '' })}
                            className="plg-cancel-modal__keep-btn"
                        >
                            Keep Subscription
                        </button>
                        <button
                            type="button"
                            onClick={this.confirmPlgCancellation}
                            disabled={!this.state.cancelReason || (this.state.cancelReason === 'Other' && this.state.cancelReasonOther.trim() === '')}
                            className="btn linear-gradient yr-submitbtn plg-cancel-modal__continue-btn"
                        >
                            Continue Cancellation <i className="fa fa-chevron-right" style={{ fontSize: '12px' }} aria-hidden />
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { loading, dismissed, showWarning, plgUsage } = this.state;

        if (loading) return null;

        // Only unpaid PLG trial users see the trial banner.
        if (this.shouldShowTrialBanner()) {
            return (
                <>
                    <div className="plg-banner-wrapper" style={{padding:"0px"}}>
                        {this.renderTrialBanner()}
                    </div>
                    {this.renderCancelModal()}
                    <DialogBox
                        show={this.state.alertModal.show}
                        title={this.state.alertModal.title}
                        message={this.state.alertModal.message}
                        toggleModal={() => {
                            const onClose = this.state.alertModal.onClose;
                            this.setState({ alertModal: { show: false, title: '', message: '' } }, () => {
                                if (onClose) onClose();
                            });
                        }}
                    />
                </>
            );
        }


        // After trial: show usage warning only when ≥80% and not dismissed
        if (!dismissed && showWarning && plgUsage) {
            return (
                <div className="plg-banner-wrapper" style={{padding:"0 28px"}}>
                    {this.renderUsageWarningBanner()}
                </div>
            );
        }

        return null;
    }
}

export default withRouter(PlgUsageWarningBanner);